




























































import { defineComponent, onBeforeUnmount, onMounted, ref, useFetch } from '@nuxtjs/composition-api'
import { useApi, useCategory } from '~/composables';
import { Logger } from '~/helpers/logger';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { GET_HOT_TOPICS } from '~/modules/catalog/category/queries/solepro/gotTopics.gql';
import { usePageResolver } from '~/stores/page';
import { temiCaldiLink, hotTopicsPageView } from '~/helpers/trackings/24orepro/pages';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';

export default defineComponent({
    components: {
        CategoryBreadcrumbs
    },
    setup() {
        const { query } = useApi();
        const { resolveUrl } = usePageResolver();
        const { loadCategoryMeta } = useCategory();
        const topics = ref([])
        const title = ref('Temi Caldi')
        const description = ref()
        const categoryMeta = ref(null);
        const trackTemiCaldiLink = async (link) => {
            await temiCaldiLink();
            location.href = link;
        }

        useFetch(async () => {
            const routeData = await resolveUrl();
            const { data } = await query(GET_HOT_TOPICS, { hotTopicsUid: routeData.uid });
            categoryMeta.value = await loadCategoryMeta({ category_uid: routeData.uid });
            try {
                const hotTopics = data['categories'].items[0];
                topics.value = hotTopics.children
                title.value = hotTopics.name
                description.value = hotTopics.description
            } catch (e) {
                Logger.warn('HotTopicsPage - no hot topics found')
            }

        })
        onMounted(()=>{
            hotTopicsPageView()
            document.getElementById('mainContent').classList.add('bg-pattern') 
            document.getElementById('mainContent').classList.add('bg-pattern--dots-grey') 
        }),
        onBeforeUnmount(()=>{
            document.getElementById('mainContent').classList.remove('bg-pattern') 
            document.getElementById('mainContent').classList.remove('bg-pattern--dots-grey') 
        })
        return {
            trackTemiCaldiLink,
            title,
            categoryMeta,
            description,
            topics
        }
    },
    head() {
        return {
          ...getMetaInfo({...(this.categoryMeta as any), title: this.title}, false, 'category')
        }
    },
})
